// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2mHme","buttons":"SendReceipts_buttons__2SAZX","email":"SendReceipts_email__5-S6F","bookApptTitle":"SendReceipts_bookApptTitle__27f33"};